<template>
  <div>
    <div>
      <h3 
        v-if="!disabled && !editName" 
        @click="editTemplateName"
        @click.stop
      >
        {{ mutableValue }}
                &nbsp;
        <span class="text-gray-600 inline-block cursor-pointer">
          <icon name="edit-2" />
        </span>
      </h3>
      <h3 v-if="disabled">
        {{ mutableValue }}
                &nbsp;
      </h3>
      <div
        v-if="!disabled && editName"
        class=""
      >
        <input
          type="text"
          class="w-full text-center
                        bg-white border rounded-md
                        placeholder-gray-600 text-gray-900
                        py-2 px-3 xxl:px-4 xxl:py-3 2xl:px-5 2xl:py-4
                        focus:outline-none focus:shadow-outline-indigo border-opacity-50
                        appearance-none transition duration-150 ease-in-out
                        text-xl sm:leading-5 block truncate
                    "
          :class="{
            'border-red-500': error && errorMsg != '',
            'border-indigo-600': !(error && errorMsg != '')
          }"
          :maxlength="maxlength"
          v-model="mutableValue"
          v-click-outside="valid"
        >
      </div>
      <div
        v-if="error && editName"
        class="text-red-500 text-sm"
      >
        {{ errorMsg }}
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../../components/Icon';

export default {
  props: {
    name: String,
    value: [String, Number],
    placeholder: String,
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    error: Boolean,
    msgError: {
      type: String,
      required:false,
      default:''
    },
    maxlength: Number,
    required: Boolean,
  },

  components:{
    Icon,
  },

  data: function () {
    return {
      mutableValue: this.value,
      errorMsg: this.msgError,
      textLibelle: '&nbsp;',
      isRequired:false,

      editName: false,
    };
  },
    
  mounted(){
    //assign text to textLibelle if prop Libelle is filled
    if(this.libelle != undefined && this.libelle != null){
      this.textLibelle = this.libelle;
    }

    //assign "required" prop value to "isRequired" data if this prop is filled
    if(this.required != undefined && this.required != null){
      this.isRequired = this.required;
    }

    if(this.msgError){
      this.errorMsg = this.msgError;
    }

  },
  methods:{
    editTemplateName(){
      if(!this.disabled){
        this.editName=true;
      }
    },

    valid(){
      if(!this.disabled){
        this.$emit('valid', this.mutableValue);
        this.editName=false;
      }
    }
  },
  watch: {
    mutableValue() {
      this.$emit('input', this.mutableValue);

      if(this.maxlength && this.mutableValue && this.mutableValue.length >= this.maxlength){
        this.errorMsg = 'Vous avez atteint la taille maximum de '+this.maxlength+' caractères.';
      }else if(this.maxlength && this.mutableValue && this.mutableValue.length < this.maxlength){
        this.errorMsg = '';
      }else if(this.msgError){
        this.errorMsg = this.msgError; 
      }else{
        this.errorMsg = '';
      }
    },

    value(){
      this.mutableValue = this.value;
    },

    msgError(){
      this.errorMsg = this.msgError; 
    }
  },

  beforeDetroy(){
    this.typeField = this.type;
  },

  directives: {
    clickOutside:{
      bind: function(el, binding, vNode) {
        // Provided expression must evaluate to a function.
        if (typeof binding.value !== 'function') {
          const compName = vNode.context.name;
          let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
          if (compName) { warn += `Found in component '${compName}'`; }

          console.warn(warn);
        }
        // Define Handler and cache it on the element
        const bubble = binding.modifiers.bubble;
        const handler = (e) => {
          if (bubble || (!el.contains(e.target) && el !== e.target)) {
            binding.value(e);
          }
        };
        el.__vueClickOutside__ = handler;

        // add Event Listeners
        document.addEventListener('click', handler);
      },

      unbind: function(el, binding) {
        // Remove Event Listeners
        document.removeEventListener('click', el.__vueClickOutside__);
        el.__vueClickOutside__ = null;
      }
    }
  }
};
</script>
